import MontuToastProvider from "@repo/components/src/globalProviders/toast";
import { Toast, ToastDescription } from "@repo/components/src/ui/toast";

export const showToast = (action: "success" | "error", message: string) => {
  MontuToastProvider.show({
    placement: "bottom",
    duration: 4000,
    render: ({ id }) => (
      <Toast nativeID={`toast-${id}`} action={action} variant="solid">
        <ToastDescription>{message}</ToastDescription>
      </Toast>
    ),
  });
};
